// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export interface ISimpleRole {
	name: string | undefined;

	organizationId: string | undefined;

	facilityId: string | undefined;

	orgName: string | undefined;

	$type?: string | undefined;
}
export class SimpleRole {
	constructor(data?: ISimpleRole) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
	}

	name: string | undefined;

	organizationId: string | undefined;

	facilityId: string | undefined;

	orgName: string | undefined;

	static $type: string = "CoreApi.Models.SimpleRole, ";
	$type?: string | undefined = SimpleRole.$type;
}

